<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
            

              <h6    class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Assets<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/cmmsassets/index"> Manage Assets  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{ customers.I_pcode }}    </h6>


                <div class="container-fluid">
                
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ customers.C_code }}  </b></h6> -->

                <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>
             





                <div v-else class="mt-3">
                <div >

                  <b-modal :id="infoModal7.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>

     <template  #modal-title>
     
     <h5 >Share by Email</h5>


   </template>
   <div class="row mb-1">
    <div class=" col-md-6">
      <input placeholder="To"  v-model="mailshair.toemail" class="form-control input5 input6 bdr-rad font-size_def" >

      
      </div>
    
   </div>
   <div class="row mb-1">
    <div class=" col-md-6">
      <input placeholder="Subject"  v-model="mailshair.subject" class="form-control input5 input6 bdr-rad font-size_def" >

      
      </div>
    
   </div>
   <div class="row mb-1">
    <div class=" col-md-12">
      <textarea placeholder="Body"  v-model="mailshair.body" class="form-control font-size_def" rows="14"></textarea>

      
      </div>
    
   </div>

   <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
     
    </div>
    <div class="d-flex  ">
      <button  type="submit" @click="mailSend()"  style="background-color: #2642a7;color: white;" class="btn btn-sm btn mb-1 font-size_def bdr-rad bdr-rad"  > Send</button>
    </div>
    </div>

   
  
  </b-modal>






                  <div class="card custom_bdr_rds shadow p-2">
                    <div class="card-body custom_bdr_rds">


                  <div class="row">

                    <div class="col-md-5">

                 
                  

                
                    <table style="font-size: small; " class="table   table-sm table-borderless  ">
       
                        <tbody >
                 
                          <tr >
                            <td class="width-custom2" style="border: 0px;" ><b>ID </b></td>
                           <td style="border: 0px;">{{ customers.idInventory }}</td> 
                           <td></td>
                          </tr>
                          <tr>
                            <td><b>Asset Code </b></td>
                           <td>{{ customers.I_pcode }}</td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Asset Name </b></td>
                           <td>{{ customers.i_product_name }}</td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Asset Description </b></td>
                           <td>{{ customers.i_pdescription }}</td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Supplier </b></td>
                           <td>{{ customers.relatedToSupplier.sup_name }}</td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Location </b></td>
                           <td>{{ customers.relatedToLocation.L_name }}</td> 
                           <td></td>
                          </tr>
                         
                         
                         
                          <tr>
                            <td><b>Department </b></td>
                           <td>{{ customers.relatedToDepartment.name }}</td> 
                           <td></td>
                          </tr>
                         
                          <tr>
                            <td><b>Warranty End Date </b></td>
                           <td >{{ customers.wrty_end_date }}  </td> 
                           <td style="text-align: right;">      
                          </td> 
                          </tr>
                          <tr>
                            <td><b>Created Date </b></td>
                           <td >{{ customers.I_created_date }}  </td> 
                           <td style="text-align: right;">      
                          </td> 
                          </tr>
                          <tr>
                            <td><b>Service contract</b></td>
                           <td >  <img
    v-if="isImage(customers.file_url)"
    :src="customers.file_url"
    alt="Preview"
    style="width: 60px; cursor: pointer;"
    @click="showImage(customers.file_url)"
  />

  <!-- Show Download Link for PDFs and documents -->
  <a 
    v-else
    :href="customers.file_url"
    target="_blank"
    style="font-size: small; color: blue; text-decoration: underline; cursor: pointer;">
    View File
  </a> </td> 
                           <td style="text-align: right;">      
                          </td> 
                           
       

     
 
                          
                          </tr>

                          <tr>
                             <td > <button style="margin-bottom: -30px;"  @click="Update()"   class="btn btn-sm  btn-outline-primary  bdr-rad"> Update</button></td>
                           <td > </td> 
                           <td style="text-align: right;">      
                          </td> 
                          </tr>
                         
                           
                        </tbody>
                 
                 
                      </table>

                    </div>

                    <div class="col-md-7">
        <div>
       <div id="map" style="height: 300px; min-height: 300px; width: 100%;"></div>
        </div>
                            </div>

                        </div>

                    </div>
                  </div>



                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Operator Contact List</b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Name</th>
                              <th>Designation</th>
                              <th>Email</th>
                              <th>Mobile No.</th>
                              <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(contact, index) in contacts" :key="contact.id">
                              <td>{{index+1}}</td>
                              <td>{{contact.name}}</td>
                              <td>{{contact.designation}}</td>
                              <td>{{contact.email}}</td>
                              <td>{{contact.tel}} No.</td>
                              <td> 
                                <a  href="#" class="button-link">Update</a> 
                                <a href="#" class="button-link">Delete</a>
                              </td>
                              </tr>
                            </tbody>

                          </table>
    
                        </div>

                        </div>
                    </div>



                    <div class="card custom_bdr_rds shadow p-2">
                      <div class="card-body custom_bdr_rds">
                          <h6 class="purchitem mb-2"><b>Service History</b></h6>
<div class="row mb-2">
  <div class="col-12 d-flex justify-content-end">
    <div class="col-md-2 p-0">
      <select v-model="filterJobType" class="form-control form-control-sm">
        <option value="">All Job Types</option>
        <option value="Repair Job">Repair Job</option>
        <option value="Preventive Job">Preventive Job</option>
      </select>
    </div>
  </div>
</div>
                          <div class="table-responsive">
                          <table style="font-size: small; " class="table table-hover  table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                              <th class="custom-label2">#</th>
                              <th>Job Num</th>
                               <th class="">Job Issue</th>
                              <th>Job Date</th>
                             
                              <th >Job type</th>
                              <th >Status</th>
                              </tr>
                            </thead>
                            <tbody>
                             
                             <tr v-for="(tran, index) in filteredTrans" :key="tran.id">
                              

                              <td>{{index+1}}</td>
                              <td>{{ tran.job_num }}</td>
                              <td>{{ tran.remark }}</td>
                              <td >{{ tran.date }}</td>
                              <td >{{ tran.job_category }} </td>
                              <td > 
                                
                              </td>
                              </tr>
                            </tbody>

                          </table>
                          </div>

                      </div>
                    </div>


                    <div class="card custom_bdr_rds shadow p-2">
                      <div class="card-body custom_bdr_rds">
                          <h6 class="purchitem mb-2"><b>Spare Parts Used</b></h6>

                          <div class="table-responsive">
                      <table style="font-size: small; " class="table table-hover  table-sm table-borderless ">
                          <thead class="background_color2" >
                            <tr class="custom-label2">
                          
                            <th>Tansaction Date</th>
                            <th>Tansaction </th>
                           
                            <th class="">Product Code </th>
                            <th class="">Product Description</th>
                             <th class="">qty</th>
                          
                            </tr>
                          </thead>
                          <tbody>
                            <tr  v-for="(invoice, index) in invoices" :key="invoice.id">
                          <td>{{ invoice.transaction_date }}</td>
                          <td>{{ invoice.transaction_no }}</td>
                          <td>{{ invoice.P_code }}</td>
                          <td>{{ invoice.P_description }}</td>
                            <td class="">{{ invoice.qty }}</td>
                      
                          
                            </tr>
                            <tr >
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>Total</td>
                            <td class="">{{ totals.qtytotals }}</td>
                       
                         
                          
                            </tr>
                          </tbody>

                        </table>
                        </div>
<br>

                      </div>
                  </div>


                  <div class="card custom_bdr_rds shadow p-2">
                    <div class="card-body custom_bdr_rds">
                        <h6 class="purchitem mb-2"><b>Service Tasks</b></h6>

                        <div class="table-responsive">
                    <table style="font-size: small; " class="table  table-hover table-sm table-borderless ">
                        <thead class="background_color2" >
                          <tr class="custom-label2"> 
                          <th>#</th>
                          <th>Comment</th>
                          <th>Visit Date</th>
                          <th>Attachments</th>
                          <th>Created Date</th>
                          <th>Created By</th>
                          
                          </tr>
                        </thead>
                        <tbody>
                          <tr  v-for="(deler, index) in delers" :key="deler.id">
                          <td>{{ index+1 }}</td>
                          <td>{{deler.comments}}</td>
                          <td>{{deler.vsit_date}}</td>
                          <td></td>
                          <td>{{deler.created_datetime}}</td>
                          <td>{{deler.relatedToUser.username}}</td>
                          
                          </tr>
                        </tbody>

                      </table>
                      </div>

               



             

                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group ">
                                  <label class="custom-label " style="font-size: small;">Comments </label>
                                  <textarea rows="3"   style="font-size: small;" class="form-control bdr-rad" ></textarea>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group ">
                                  <label class="custom-label" style="font-size: small;">Vsit Date</label>
                                  <input type="date"  style="font-size: small;" class="form-control bdr-rad" >
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group ">
                                  <label class="custom-label" style="font-size: small;">Attachment</label>
                                  <input type="file"  style="font-size: small;" class="form-control bdr-rad" >
                          </div>
                        </div>


                      </div>

                     


                      <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                    <div class="d-flex  ">
                    
                    </div>
                    <div class="d-flex  ">
                        <button class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Add Dealer Visit</button>
                    </div>
                    </div>
                  


                  </div>
              </div>



             



            <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>Service Notes</b></h6>

                  <div class="table-responsive">
                  
                  <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                  <thead class="background_color2"  >
                    <tr class="custom-label2">
                    <th>#</th>
                    <th>Comment</th>
                    <th>File</th>
                    <th>Code</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="(mservicelog, index) in mservicelogs" :key="mservicelog.idServicelog">
                    <td>{{index+1}}</td>
                    <td>{{ mservicelog.comments }}</td>
                 <td>
                  <img
                    :src="mservicelog.attach_file"
                    alt="Preview"
                    style="width: 60px; cursor: pointer;"
                    @click="showImage(mservicelog.attach_file)"
                  />
                </td>
                    <td>{{ mservicelog.num_code }}</td>
                    <td>{{ mservicelog.job_type }}</td>
                    <td>{{ mservicelog.created_date }}</td>
                    <td>{{ mservicelog.username }}</td>
                    <td>{{ mservicelog.followup_date }}</td>
                    <td>{{ mservicelog.followusername }}</td>
                  
                    
                    </tr>
                  </tbody>

                </table>
                <b-modal
                  id="image-modal"
                  v-model="showImageModal"
                  size="md"
                  hide-footer
                  title="Image Preview"
                >
                  <img :src="currentImage" alt="Full Image" style="width: 100%;" />
                </b-modal>
                  </div>

          
<br>

       
             

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3" v-model="crm.comments"  style="font-size: small;" class="form-control bdr-rad" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select style="font-size: small;" class="form-select bdr-rad" v-model="crm.job_type">
                              <option  selected>Select....</option>
                              <option >Repair Job</option>
                              <option  >Preventive Job</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input v-model="crm.followup_date" type="date"  style="font-size: small;" class="form-control bdr-rad" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input v-model="username"  style="font-size: small;" class="form-control bdr-rad" disabled>
                    </div>
                  </div>


                </div>



                  <div class="row">
                        <div class="col-md-3">
                          <div class="form-group ">
                                  <label class="custom-label " style="font-size: small;">Files</label>
                                   <input type="file" style="font-size: small;"  @change="handleFileUpload"  class="form-control bdr-rad" />
                          </div>
                        </div>

                  </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                  <button @click="snedEmail()"  class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Share by Email</button>
                    <button @click="crmCreate()"  class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Add Note</button>
                    
                </div>
                </div>

            </div>
        </div>


        <div class="card custom_bdr_rds shadow p-2">
                <div class="card-body custom_bdr_rds">
                    <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>
                    <div class="table-responsive">
                    
                <table style="font-size: small; " class="table table-hover  table-sm table-borderless ">
                    <thead class="background_color2" >
                      <tr class="custom-label2">
                      <th>#</th>
                      <th>Field Name</th>
                      <th>Comment</th>
                      <th>Action</th>
                      <th>Created Date</th>
                      <th>Created Time	</th>
                      <th>Created By	</th>
                      <th>Previous Value	</th>
                      
                      </tr>
                    </thead>
                    <tbody>
                      <tr  v-for="(contact, index) in contacts" :key="contact.id">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      
                      </tr>
                    </tbody>

                  </table>
                    </div>

                </div>
            </div>

<br><br>





                




                </div>
                </div>
                </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
   
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadMcutomer()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'idcustomer':this.$route.query.id,
            username:authService.isUsername(),
            customers:{},
            contacts:[],
            map: null,
            trans:[],
            filterJobType: "",
             showImageModal: false,
    currentImage: '',
            mservicelogs:[],
            mailshair:{},
            crm:{},
            invoices:[],
            totals:[],
            delers:[],
            isLoading:true,
            infoModal7: {
          id: 'info-modal7',
          title: '',
          content: [],
        },
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },

        computed: {
  filteredTrans() {
    if (this.filterJobType === "") {
      return this.trans;
    }
    return this.trans.filter(t => t.job_category === this.filterJobType);
  }
},

        methods : {
 showImage(imagePath) {
    this.currentImage = imagePath;
    this.showImageModal = true;
  },

  isImage(file_url) {
  if (!file_url) return false;

  const ext = file_url.split('.').pop().toLowerCase();
  return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
},

         async crmCreate2() {
       
    
       try {
         const { data} = await  axios.post('/ciinventory/crmcreate?id='+this.idcustomer,{crm:this.crm,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadMcutomer();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },

               handleFileUpload(event) {
      this.file = event.target.files[0];
    },


      async crmCreate() {
  if (!this.file) {
    alert("Please select an Excel file first.");
    return;
  }

  const formData = new FormData();
  formData.append("excel_file", this.file);
  formData.append("crm", JSON.stringify(this.crm));
  formData.append("userid", JSON.stringify(this.userid));


  try {
    const response = await axios.post(
      "/ciinventory/crmcreate?id="+this.idcustomer,
      formData,
      {
        headers: {
          Authorization: "Bearer " + this.access_token,
        "Content-Type": "multipart/form-data",
        //'Content-type': 'application/json',
        },
      }
    );

    const data = response;
      console.log(data);
    if (data.status == 200) {
      alert("Product data uploaded successfully!");
          this.loadMcutomer();
     // window.location.reload();
      
    } else {
      console.error("Upload failed:", data.message || data);
      alert("Upload failed. Please check the file format or server logs.");
    }
  } catch (error) {
    console.error("Upload error:", error.response || error);
    alert("An error occurred while uploading the file.");
  }
},

       

     

   


          async mailSend(id){

this.$root.$emit('bv::hide::modal', this.infoModal7.id);
try {
  const { data} = await  axios.post('/issuetracking/issuemailsend1?id='+id,{userid:this.userid,mailshair:this.mailshair,idcustomer:this.idcustomer},{
    headers:{
      'Authorization':'Bearer '+this.access_token,
      'Content-type': 'application/json',
     
    }
   });
   console.log(data);
   if(data.status==200){
   window.location.reload();
  
    
   
   }
  
} catch (error) {
  console.log(error.response);
  
}

},




          async snedEmail(id){

            this.infoModal7.content = id;
            this.$root.$emit('bv::show::modal', this.infoModal7.id);



          },
          async Update(){
        this.$router.push('/cmmsassets/update?id='+this.idcustomer);
      },

            async loadMcutomer(id) {
        console.log("Amila");
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/ciinventory/view?id='+this.idcustomer,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.customers = data.item_list;
         this.contacts = data.item_det;
         this.trans = data.item_acount_tran;
         this.invoices = data.invoices;
         this.totals = data.totals;
         this.delers = data.delers;
         this.mservicelogs = data.mservicelogs;
         this.isLoading= false;
        
      } catch (error) {
        console.log(error.response);
      }


     if (this.customers.latitude && this.customers.longitude) {
    this.$nextTick(() => {
      const map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: parseFloat(this.customers.latitude), lng: parseFloat(this.customers.longitude) },
        zoom: 13
      });

      new google.maps.marker.AdvancedMarkerElement({
        map: map,
        position: { lat: parseFloat(this.customers.latitude), lng: parseFloat(this.customers.longitude) },
        title: 'Location of the issue'
      });
    });
  
}

    





    },


   

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.manage-boder{
      border-bottom: 2px solid #007bff;
      border-top: 2px solid #007bff;
      padding-bottom: 10px !important;
      padding-top: 10px !important;
      
  }



.button-link:hover {
  color: black;
  text-decoration: underline;
}
.decoration{
      text-decoration: none;
      color:white !important;
    }
    </style>